import React from 'react'
import PropTypes from 'prop-types'

import { getImageURL } from 'utils/image'

import * as S from './styled'

/* eslint multiline-ternary: "off" */
const Background = ({ illustration, mutedVideo, setContentTime }) => {
  if (illustration?.data && illustration.data.attributes.mime.includes('video')) {
    const videoSource = illustration.data.attributes.preloadedurl || illustration.data.attributes.url
    const videoType = illustration.data.attributes.mime

    const handleVideoDuration = duration => {
      setContentTime(duration * 1000)
    }

    return (
      <S.BackgroundVideo
        className='background-video'
        muted={mutedVideo}
        source={videoSource}
        type={videoType}
        getVideoDuration={handleVideoDuration}
      />
    )
  }

  return <S.BackgroundImage className='background-image' src={getImageURL(illustration)} />
}

Background.defaultProps = {
  mutedVideo: true,
  setContentTime: () => {},
}

Background.propTypes = {
  illustration: PropTypes.object,
  mutedVideo: PropTypes.bool,
  setContentTime: PropTypes.func,
}

export default Background
